<template>
    <v-dialog
        ref="notificationModal"
        v-bind="$attrs"
        :value="dialog"
        max-width="768px"
        v-on="$listeners"
        @click:outside="close"
    >
        <v-card v-if="notification" class="notification-modal">
            <v-card-title>
                <h2>{{ t('notifications::page.title.read_notification') }}</h2>
                <v-icon color="#a5a5a5" @click="close()">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-form readonly>
                    <div :class="`notification-header my-5 color-${notification.color}`">
                        <v-row>
                            <v-col cols="12" lg="6">
                                <h5>{{ t('notifications::types.' + notification.type) }}</h5>
                            </v-col>
                            <v-col cols="12" lg="6" class="d-flex justify-content-end">
                                <div :class="`notification-status ${notification.status}`">
                                    <span
                                        v-text="
                                            notification.status === 'new'
                                                ? t('notifications::statuses.new')
                                                : t('notifications::statuses.completed')
                                        "
                                    ></span>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" lg="4">
                                <div class="notification-field">
                                    <label class="label">{{ t('notifications::grid.label.created_at') }}</label>
                                    <div class="value">
                                        {{ moment(notification.created_at).format($root.dateFormatWithHours) }}
                                    </div>
                                </div>
                            </v-col>
                            <v-col v-if="notification.created_by && notification.created_by.name" cols="12" lg="4">
                                <div class="notification-field">
                                    <label class="label">{{ t('notifications::grid.label.created_by') }}</label>
                                    <div class="value">{{ notification.created_by.name }}</div>
                                </div>
                            </v-col>
                            <v-col v-if="notification.completed_by && notification.completed_by.name" cols="12" lg="4">
                                <div class="notification-field">
                                    <label class="label">{{ t('notifications::grid.label.completed_by') }}</label>
                                    <div class="value">{{ notification.completed_by.name }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-if="notification.memo">
                        <v-textarea
                            v-model="notification.memo"
                            :label="t('notifications::grid.label.memo')"
                            rows="3"
                            rounded
                            disabled
                            dense
                            outlined
                        >
                        </v-textarea>
                    </div>
                    <div v-if="request && request.entity_class === 'Bgo\\Patients\\Data\\Entities\\Patient'">
                        <notification-patient-approval-request> </notification-patient-approval-request>
                    </div>
                    <div v-if="request && request.entity_class === 'Bgo\\Consultants\\Data\\Entities\\Consultant'">
                        <notification-consultant-approval-request> </notification-consultant-approval-request>
                    </div>
                    <div v-if="request && request.entity_class === 'Bgo\\Laboratories\\Data\\Entities\\Laboratory'">
                        <notification-laboratories-approval-request> </notification-laboratories-approval-request>
                    </div>
                    <div
                        v-if="
                            request &&
                            request.entity_class === 'Bgo\\CollectionCentres\\Data\\Entities\\CollectionCentre'
                        "
                    >
                        <notification-collection-centre-approval-request>
                        </notification-collection-centre-approval-request>
                    </div>
                    <div v-if="request && request.entity_class === 'Bgo\\PharmacySites\\Data\\Entities\\PharmacySite'">
                        <notification-pharmacy-sites-approval-request> </notification-pharmacy-sites-approval-request>
                    </div>
                    <div
                        v-if="request && request.entity_class === 'Bgo\\PharmacyGroups\\Data\\Entities\\PharmacyGroup'"
                    >
                        <notification-pharmacy-groups-approval-request> </notification-pharmacy-groups-approval-request>
                    </div>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" text rounded class="px-6" @click="close()">{{
                    t('default::button.cancel')
                }}</v-btn>
                <v-btn
                    v-if="can('api.v1.notifications.complete') && notification.status === 'new'"
                    color="primary"
                    rounded
                    :loading="actionCompletedLoading"
                    class="px-6 ml-6"
                    @click="markAsCompleted()"
                    >{{ t('notifications::button.mark_as_completed') }}</v-btn
                >
                <v-btn
                    v-if="canApprove"
                    :loading="actionApproveLoading"
                    color="primary"
                    rounded
                    class="px-6 ml-6"
                    @click="approveRequest()"
                    >{{ t('notifications::button.approve_request') }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'NotificationModal',
    components: {},
    props: {
        dialog: {
            type: Boolean,
            default: false,
            require: true,
        },
    },
    data() {
        return {
            actionCompletedLoading: false,
            actionApproveLoading: false,
        };
    },
    computed: {
        canApprove() {
            if (!this.notification || !this.notification.action_data || !this.notification.action_data.request) {
                return false;
            }
            return this.can(this.notification.action_data.request.approveRoute) && !this.request.approved_by_id;
        },
        request() {
            return this.$store.state.notifications.request;
        },
        notification() {
            return this.$store.state.notifications.current;
        },
    },
    watch: {},
    created() {},
    methods: {
        close() {
            this.$store.dispatch('notifications/resetRequest');
            this.$emit('close-dialog');
        },
        markAsCompleted() {
            if (!this.notification && !this.notification.id) {
                return;
            }
            this.actionCompletedLoading = true;
            axios
                .put(
                    route('api.v1.notifications.complete', {
                        notification: this.notification.id,
                    })
                )
                .then(() => {
                    this.$emit('completed', this.notification.id);
                    this.$store.dispatch('notifications/fetchNotifications');
                    this.close();
                    this.$root.notify(
                        'info',
                        t('notifications::notification.title.marked_as_completed'),
                        t('notifications::notification.text.marked_as_completed')
                    );
                })
                .finally(() => _.delay(() => (this.actionCompletedLoading = false), 400));
        },
        approveRequest() {
            const approveRoute = this.notification.action_data.request.approveRoute || false;
            if (!this.notification && !this.notification.action_data && !can(approveRoute)) {
                this.$root.notify('warning', t('notifications::notification.not_have_permission_to_approve_request'));
                return this.close();
            }
            this.actionApproveLoading = true;
            axios
                .post(
                    route(approveRoute, {
                        request: this.notification.action_data.request.id,
                    })
                )
                .then(() => {
                    this.close();
                    this.markAsCompleted();
                    this.$root.notify(
                        'info',
                        t('notifications::notification.title.successfully_approved'),
                        t('notifications::notification.text.successfully_approved')
                    );
                    _.delay(() => (this.actionApproveLoading = false), 400);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        const errors = error.response.data?.errors || false;
                        if (errors) {
                            const errorsMessages = errors.map((e) => e.errors.join('<br/>')).join('<br/>');
                            this.$root.notify('error', errorsMessages);
                        }
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => (this.actionApproveLoading = false));
        },
    },
};
</script>
